export default __webpack_public_path__ + "static/media/blog-img.01207236.jpg";